// @flow
import React, { Component } from "react";
import moment from "moment";
import TextTruncate from "react-text-truncate";
import LazyLoad from "react-lazyload";
import I18n from "../../../../i18n/I18n";
import Icon from "../../../common/Icon";
import Button from "../../../common/button/Button";
import Dropdown from "../../../common/dropdown/Dropdown";
import Helper from "../../../../helper/Helper";
import CONFIG from "../../../../config/";
import styles from "./OrderDetailsBox.scss";

class OrderDetailsBox extends Component {
  state: {
    acceptedQty: string
  };
  selectQtyChange: Function;
  constructor(props) {
    super(props);
    this.state = {
      acceptedQty: props.order.accepted_quantity
    };
  }
  selectQtyChange(e: Object) {
    this.setState({
      acceptedQty: e.value
    });
    const changedOffer = {
      id_offer: this.props.order.idOffer,
      quantity: e.value
    };
    this.props.onQtyChange(changedOffer);
  }
  render() {
    const order = this.props.order || "";
    const placeholder = (
      <img
        src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
        alt="Placeholder"
      />
    );

    const qtyOptions = [];
    for (let i = order.accepted_quantity; i >= 0; i--) {
      qtyOptions.push({ value: i, label: `${i}` });
    }

    return (
      <div
        className={styles.ctr}
        onClick={() => this.props.openDetail(order.idOffer)}
      >
        <div className={styles.productWrapper}>
          <div className={styles.imageSection}>
            <div className={styles.imageNameWrapper}>
              <div className={styles.imageCtr}>
                <LazyLoad
                  height="100%"
                  once
                  placeholder={placeholder}
                  offset={100}
                >
                  <img
                    src={Helper.getTransformationUrl(order.imagekey)}
                    alt="detail_img"
                  />
                </LazyLoad>
              </div>
              <div className={styles.names}>
                {order.itemName ? (
                  <TextTruncate
                    line={2}
                    text={order.itemName}
                    containerClassName={styles.productName}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className={styles.statusCtr}>
              <div className={styles.attrVal}>{order.sku}</div>
              <div className={styles.attrVal}>
                {I18n.formatCurrency(
                  Helper.formatPrice(order.price, this.props.currencyCode)
                )}
              </div>
            </div>
          </div>
          <div className={styles.descCtr}>
            <div className={styles.attrCtr}>
              <div className={styles.eachAttr}>
                <h6 className={styles.attrTitle}>
                  {I18n.getText("order-details.p-sku", {}, "Partner SKU")}
                </h6>
                <div className={styles.attrVal}>{order.partnerSku}</div>
              </div>
              <div className={styles.eachAttr}>
                <h6 className={styles.attrTitle}>
                  {I18n.getText("order-details.units", {}, "Units")}
                </h6>
                <div className={styles.attrVal}>{order.quantity}</div>
              </div>
              <div className={styles.eachAttr}>
                <h6 className={styles.attrTitle}>
                  {I18n.getText(
                    "order-details.accepted-qty",
                    {},
                    "Accepted Quantity"
                  )}
                </h6>
                <div className={styles.attrVal}>
                  {this.props.modifiable ? (
                    <Dropdown
                      options={qtyOptions}
                      height="short"
                      value={this.state.acceptedQty}
                      onChange={e => this.selectQtyChange(e)}
                    />
                  ) : (
                    this.state.acceptedQty
                  )}
                </div>
              </div>
            </div>
            <div className={styles.priceWrapper}>
              <h6 className={styles.attrTitle}>
                {I18n.getText(
                  "order-details.subtotal",
                  {
                    currency: I18n.formatCurrency({
                      currency: this.props.currencyCode
                    })
                  },
                  "Subtotal ({currency})"
                )}
              </h6>
              <div className={styles.attrVal}>
                {I18n.formatCurrency(
                  Helper.formatPrice(order.itemTotal, this.props.currencyCode)
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OrderDetailsBox.propTypes = {};

OrderDetailsBox.getDefaultProps = {};

export default OrderDetailsBox;



// WEBPACK FOOTER //
// ./src/components/orders/orderDetails/orderDetailsBox/OrderDetailsBox.js